<template>
    
    <div class="container m-auto py-24 px-4" >

        <div>

            <p class="text-gray-500" >Lorem Ipsum</p>

            <h1 class="text-4xl font-medium" >Invoices</h1>

        </div>

        <div class="mt-10" >

            <div class="w-full 
                        h-12 
                        bg-gray-100 
                        px-8
                        grid 
                        grid-cols-20
                        items-center
                        gap-6 
                        border-gray-300 
                        border-solid
                        rounded-b-none"

            :class="{ 
                'border-b': stickyHeader,
                'rounded-cs-md': !stickyHeader
            }"

            v-sticky:80="setStickyHeader" 
            v-not-sticky:80="removeStickyHeader" 
            
            >

                <p class="text-sm text-gray-600 h-full flex items-center col-span-2" >Number</p>

                <p class="text-sm text-gray-600 h-full flex items-center col-span-2" >Clinic</p>

                <p class="text-sm text-gray-600 h-full flex items-center col-span-2" >Date</p>

                <p class="text-sm text-gray-600 h-full flex items-center justify-end col-span-2 col-start-15" >Status</p>

                <p class="text-sm text-gray-600 h-full flex items-center justify-end col-span-2" >Cost</p>

                <div class="text-sm text-gray-600 h-full flex items-center col-span-2" ></div>

            </div>

            <invoice 
            
            :key="item.id"
            :invoice="item"
            
            v-for="item in invoices" 
            
            />

            <div 
            
            class="w-full h-20 bg-gray-100 flex items-center p-4 border-gray-300 border-solid rounded-t-none" 
            
            :class="{
                'border-t': stickyFooter,
                'rounded-cs-md': !stickyFooter
            }"
            
            v-sticky:0.bottom="setStickyFooter" 
            v-not-sticky:0.bottom="removeStickyFooter"

            >

                <p class="text-sm flex-grow" >{{ invoices.length }} TOTAL</p>

                <p class="text-xs text-right text-gray-500 mr-4" >Select multiple invoices <br /> and pay them at once.</p>

                <button class="btn" >Bulk Pay</button>

            </div>

        </div>

    </div>

</template>

<script>

    import { ref, computed } from 'vue'
    import { useStore } from 'vuex'

    import { sticky, notSticky } from '../assets/scripts/sticky'

    import invoice from '../components/invoice'

    export default {
    
        name: 'Invoices',

        components: { invoice },

        setup( props, context ) {

            const store = useStore()
            const invoices = computed(() => store.state.invoices.invoices ) 

            const stickyHeader = ref(false)

            const setStickyHeader = () => { stickyHeader.value = true }
            const removeStickyHeader = () => { stickyHeader.value = false }

            const stickyFooter = ref(false)

            const setStickyFooter = () => { stickyFooter.value = true }
            const removeStickyFooter = () => { stickyFooter.value = false }

            return {
                invoices,
                stickyHeader,
                stickyFooter,
                setStickyHeader,
                setStickyFooter,
                removeStickyHeader,
                removeStickyFooter
            }

        },

        directives: { sticky, notSticky }

    }

</script>